import { createContext, useContext } from 'react';

import type { AnalyticsFacade } from './AnalyticsFacade';

export const AnalyticsContext = createContext<AnalyticsFacade>(
  {} as AnalyticsFacade,
);

export const useAnalyticsFacade = () => useContext(AnalyticsContext);
